import { Lock } from "lucide-react";
import { idr } from "../../../lib/api";
import { formatTanggal } from "../../../lib/tanggal";

// Ringkasan total per program (brief: "Sistem otomatis menghitung Total ... pada
// masing-masing program") — angka dari backend apa adanya. Komponen murni
// (tanpa api/useAuth) supaya bisa dirender tes node apa adanya. Program Selesai
// menampilkan angka SNAPSHOT yang disetujui PIC.
export default function RingkasanSelesai({ status }) {
  const snap = status.snapshot;
  const r = status.ringkasan || {};
  const total = snap ? snap.total_hak : r.total_hak;
  const belum = snap ? snap.hak_dilepas : r.hak_belum_diklaim;
  const kotak = [
    { key: "total", label: snap ? "Total Hak (dibekukan)" : "Total Hak", v: total, tone: "text-emerald-700" },
    { key: "belum", label: snap ? "Hak Dilepas (Hangus)" : "Eligible Belum Diklaim", v: belum, tone: "text-rose-700" },
  ];
  return (
    <div className="space-y-2" data-testid="cb-selesai-ringkasan">
      {snap && (
        <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-3 text-sm text-indigo-900" data-testid="cb-selesai-snapshot">
          <p className="font-semibold flex items-center gap-1.5"><Lock className="w-4 h-4" /> Program SELESAI — disetujui {snap.disetujui_oleh_nama} · {formatTanggal(snap.disetujui_at, { denganJam: true })}</p>
          <p className="text-xs mt-1">Diajukan {snap.diajukan_oleh_nama || snap.diajukan_oleh}{snap.catatan ? ` — ${snap.catatan}` : ""}. Daftar unit, rekap, dan laporan program ini dibaca dari snapshot saat disetujui.</p>
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {kotak.map((k) => (
          <div key={k.key} className="bg-slate-50 border border-slate-200 rounded-lg p-3" data-testid={`cb-selesai-kotak-${k.key}`}>
            <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{k.label}</p>
            <p className={`font-display text-lg font-bold ${k.tone}`}>{idr((k.v || {}).total_cashback || 0)}</p>
            <p className="text-[11px] text-slate-500">{(k.v || {}).count || 0} unit</p>
          </div>
        ))}
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-3" data-testid="cb-selesai-kotak-uang">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">Uang Diterima</p>
          <p className="font-display text-lg font-bold text-slate-900">{idr((snap ? snap.uang_diterima : r.uang_diterima) || 0)}</p>
          <p className="text-[11px] text-slate-500">{snap ? snap.jumlah_baris : r.jumlah_baris} unit di program</p>
        </div>
      </div>
    </div>
  );
}
